/**
 * Help content and FAQ for end users (Web version)
 */

export const helpSections = [
  {
    id: 'getting-started',
    title: 'Getting Started',
    icon: '🚀',
    content: [
      {
        question: 'What is ARFTCHC?',
        answer: 'ARFTCHC is a horse racing prediction game where you pick horses and win virtual currency based on their performance. Compete with friends on the leaderboard and track your success rate!'
      },
      {
        question: 'How do I get started?',
        answer: 'Simply browse the Races page to see upcoming races, click on a race to view horses and their odds, then make your predictions. After races complete, check the Results page to see if you won!'
      },
      {
        question: 'Do I need to pay money?',
        answer: 'No! This is a free prediction game using virtual currency. All winnings are for fun and leaderboard bragging rights.'
      }
    ]
  },
  {
    id: 'making-picks',
    title: 'Making Picks',
    icon: '🐎',
    content: [
      {
        question: 'How do I pick horses?',
        answer: 'Go to the Races page and select a race. You\'ll see a list of horses with their odds. Pick 3 horses you think will finish in the top 3 positions. The system calculates your potential payout based on the odds.'
      },
      {
        question: 'What are odds?',
        answer: 'Odds show how likely a horse is to win according to bookmakers. Lower odds (5/2) mean higher chance of winning but smaller payouts. Higher odds (15/1) mean lower chance but bigger payouts if they win.'
      },
      {
        question: 'Can I change my picks?',
        answer: 'Yes! You can edit your picks any time before the race starts. Once a race begins, picks are locked in.'
      },
      {
        question: 'What is the 3-horse pick system?',
        answer: 'You pick 3 horses per race. Your payout is calculated based on how many finish in the top 3 positions, weighted by their odds. The better your horses perform, the more you win!'
      }
    ]
  },
  {
    id: 'results-winnings',
    title: 'Results & Winnings',
    icon: '🏆',
    content: [
      {
        question: 'How do I see my results?',
        answer: 'Go to the Results page to see all completed races. You can also check My Picks to see your active and past picks with their status and winnings.'
      },
      {
        question: 'How are payouts calculated?',
        answer: 'Payouts depend on how many of your 3 horses finish in the top 3, and their odds. Even if not all your horses place, you can still earn partial winnings. The app shows your potential and actual payouts.'
      },
      {
        question: 'Where do I see my total winnings?',
        answer: 'Your total winnings are displayed on your Account settings page and in the Leaderboard. Track your progress over time!'
      },
      {
        question: 'What is win rate?',
        answer: 'Your win rate is the percentage of picks where at least one of your horses placed in the top 3. It shows your prediction accuracy.'
      }
    ]
  },
  {
    id: 'leaderboard',
    title: 'Leaderboard',
    icon: '🏅',
    content: [
      {
        question: 'How does the leaderboard work?',
        answer: 'The leaderboard ranks all users by total winnings. Compete with friends to see who has the best prediction skills! It updates automatically as races complete.'
      },
      {
        question: 'How do I improve my rank?',
        answer: 'Make smart picks! Study the horses and odds, pick consistently, and manage your risk. Picking favorites is safe but pays less, while underdogs can boost your winnings significantly.'
      },
      {
        question: 'Can I see other users\' picks?',
        answer: 'Yes!, You can view other users\' picks and their reasoning for each pick. You can also discuss your picks and strategies in the Chat feature to learn from others and improve your own predictions.'
      }
    ]
  },
  {
    id: 'features',
    title: 'Other Features',
    icon: '⭐',
    content: [
      {
        question: 'What is the Chat feature?',
        answer: 'Chat lets you discuss races, strategies, and results with other users. Use it to share tips, celebrate wins, or commiserate losses!'
      },
      {
        question: 'What are Tidbits?',
        answer: 'Tidbits are the factoids, handicapping rankings and musings of the Annoyed Handicapper (TM). They provide quick horse racing facts, tips, and interesting information to help you make better predictions. Check them out for insights!'
      },
      {
        question: 'Can I have multiple accounts?',
        answer: 'Primary account holders can request dependent accounts (for family members, children, friends.. anybody who lacks access to the app). Submit a request via the Account settings page to set this up. Requires admin approval.'
      },
      {
        question: 'How do I update my profile?',
        answer: 'Go to Account settings to update your display name, email, and password. You can also switch between dependent accounts if you have them.'
      }
    ]
  },
  {
    id: 'tips',
    title: 'Pro Tips',
    icon: '💡',
    content: [
      {
        question: 'Any tips for beginners?',
        answer: 'Start by picking a mix of favorites and underdogs. Don\'t always pick the lowest odds - sometimes mid-range horses (odds 5-10) offer the best risk/reward balance. Check race history and horse performance when available.'
      },
      {
        question: 'Should I pick all favorites?',
        answer: 'Favorites win more often but pay less. Picking all favorites might keep you steady but won\'t boost you up the leaderboard quickly. Mix in some calculated risks!'
      },
      {
        question: 'What if I miss a race?',
        answer: 'No worries! There are always more races coming up. Focus on making quality picks rather than picking every single race. If you have technical issues, contact support and we can help sort it out. If you are unable to submit picks in the app before post time, send your picks to eryder4868@aol.com, or support@support.mapryder.com and we will manually enter them for you as long as it is before the race starts.'
      }
    ]
  }
];
